import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=631ee26c&scoped=true"
import script from "./Start.vue?vue&type=script&lang=ts"
export * from "./Start.vue?vue&type=script&lang=ts"
import style0 from "@/assets/css/scoped/start-style.css?vue&type=style&index=0&id=631ee26c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631ee26c",
  null
  
)

/* custom blocks */
import block0 from "@/assets/locales/i18n-start.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2FStart.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports